export const HEADER_HEIGHT = 54;

function watchToggle(selector: string, fn: (state: boolean) => void) {
  const toggle: HTMLInputElement = document.querySelector(selector) as HTMLInputElement;
  toggle.addEventListener("change", () => {
    fn(toggle.checked);
  });

  fn(toggle.checked);
}

let palette = document.getElementById("palette")!;
watchToggle("#palette-toggle", (state: boolean) => {
  palette.style.display = state ? "block" : "none";
});

interface Settings {
  flipped: boolean;
  raw: boolean;
}
export const settings: Settings = {
  flipped: false,
  raw: false,
}

watchToggle("#flipped-toggle", (state: boolean) => {
  settings.flipped = state;
});
watchToggle("#raw-toggle", (state: boolean) => {
  settings.raw = state;
});

const canvas = document.querySelector("canvas") as HTMLCanvasElement;
const rotateButton = document.querySelector("#rotate-button") as HTMLButtonElement;
let rotation = 0;
rotateButton.addEventListener("click", () => {
  rotation = (rotation + 90) % 360;
  canvas.style.transform = `rotate(${rotation}deg)`;
});